import React, { useMemo, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import { getCurrentDateFormatted, romanNum } from "../../../../utilities/Utils";
import UserService from "../../../../services/user/UserService";
import { AsyncPaginate } from "react-select-async-paginate";
import SweetAlert from "react-bootstrap-sweetalert";

const ModalSpt = ({ showAddSpt, handleCloseAddSpt, rowData, reloadList }) => {

    const [showConfirmSpt, setShowConfirmSpt] = useState(false)
    const handleCloseConfirmSpt = () => setShowConfirmSpt(false)
    const [showSptSuccess, setShowSptSuccess] = useState(false)
    const [showSptFailed, setShowSptFailed] = useState(false)

    const currentDate = new Date()
    const currentMonth = currentDate.getMonth() + 1
    const currentYear = currentDate.getFullYear()

    let pbumkuService = useMemo(() => new PbUmkuService(), [])
    let userService = useMemo(() => new UserService(), [])

    const [nomorAgenda, setNomorAgenda] = useState(null)
    const [tanggalAgenda, setTanggalAgenda] = useState(getCurrentDateFormatted())
    const [loadAmbilNomor, setLoadAmbilNomor] = useState(false)
    const [disableBtnNomor, setDisableBtnNomor] = useState(false)
    const [valueUptOpt, setValueUptOpt] = useState(null)
    const [valueKdUpt, setValueKdUpt] = useState(null)
    const [valueTtdOpt, setValueTtdOpt] = useState(null)
    const [valueTtdNama, setValueTtdNama] = useState(null)
    const [valueTtdJabatan, setValueTtdJabatan] = useState(null)
    const [valueTtdNip, setValueTtdNip] = useState(null)

    const handleClickAmbilNomor = async () => {
        try {
            setLoadAmbilNomor(true)
            const resp = await pbumkuService.ambilNomorService('SPT', 'P', currentYear, localStorage.getItem("username"))
            setNomorAgenda(resp.data.kodePusat + '-' + resp.data.nomorUrut + '/' + resp.data.uraianPusat + '/' + romanNum(currentMonth) + '/' + currentYear)
            setLoadAmbilNomor(false)
            setDisableBtnNomor(true)
        } catch (error) {
            console.log(error)
        }
    }

    async function loadOptionUpt(search, loadedOption, { page = 1 }) {
        const response = await userService.listUpt(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    async function loadOptionPenandatangan(search, loadedOption, { page = 1}) {
        const response = await pbumkuService.listPenandatangan(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            additional: {
                page: page + 1
            }
        }
    }

    const onChangeUpt = e => {
        setValueUptOpt(e)
        setValueKdUpt(e.kdUnit)
    }

    const onChangePenandatangan = e => {
        setValueTtdOpt(e)
        setValueTtdNama(e.namaPenandatangan)
        setValueTtdJabatan(e.jabatanPenandatangan)
        setValueTtdNip(e.nipPenandatangan)
    }

    const onChangeTanggalAgenda = e => {
        setTanggalAgenda(e.target.value)
    }

    const SaveSpt = () => {
        setShowConfirmSpt(true)
    }

    const handleClickSpt = async () => {
        try {
            let jsonSpt = {
                idoss: rowData.idoss,
                idpryk: rowData.idpryk,
                idchecklist: rowData.idchecklist,
                nib: rowData.nib,
                nomorSpt: nomorAgenda,
                tanggalSpt: tanggalAgenda,
                kdUpt: valueKdUpt,
                namaIzin: rowData.namaIzin,
                pejabatTtd: valueTtdNama,
                jabtanTtd: valueTtdJabatan,
                createdBy: localStorage.getItem('userId'),
                nip: valueTtdNip
            }
            // console.log(jsonSpt)
            const _resSpt = await pbumkuService.saveSpt(jsonSpt)
            if(_resSpt.data.kode === '200'){
                setShowSptSuccess(true)
                setShowConfirmSpt(false)
            }
        } catch (error) {
            setShowSptFailed(true)
            console.log(error)            
        }
    }

    const handleClickSptSuccess = () => {
        setShowSptSuccess(false)
        // window.location.reload()
        handleCloseAddSpt()
        setDisableBtnNomor(false)
        setNomorAgenda(null)
        setTanggalAgenda(getCurrentDateFormatted())
        setValueUptOpt(null)
        setValueKdUpt(null)
        setValueTtdOpt(null)
        setValueTtdNama(null)
        setValueTtdJabatan(null)
        reloadList(0, 10)
    }

    const handleClickSptFailed = () => {
        setShowSptFailed(false)
    }

    return (
        <>
            <Modal show={showAddSpt} onHide={handleCloseAddSpt} backdrop='static' keyboard={false} scrollable={true} size="lg" centered>
                <Modal.Header><h6>Buat Surat Perintah Tugas</h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">NIB</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nib} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor Proyek</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Nomor SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-8 form-control-sm" name="nomor_spt" defaultValue={nomorAgenda} disabled />{' '}
                            <Button variant="secondary" size="sm" onClick={() => handleClickAmbilNomor()} disabled={disableBtnNomor}>Ambil Nomor {loadAmbilNomor && <Spinner />}</Button>{' '}
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Tanggal SPT</label>
                        <div className="col-sm-4">
                            <input type="date" className="col-sm-12 form-control-sm" name="tanggal_spt" onChange={onChangeTanggalAgenda} defaultValue={tanggalAgenda}/>
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">UPT</label>
                        <div className="col-sm-10">
                            {/* <input type="text" className="col-sm-12 form-control-sm" name="upt" placeholder="UPT" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionUpt}
                                value={valueUptOpt}
                                getOptionValue={(option) => option.kdUnit}
                                getOptionLabel={(option) => option.nmUnit}
                                additional={{
                                    page: 1,
                                }}
                                onChange={onChangeUpt}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Pejabat Penandatangan</label>
                        <div className="col-sm-10">
                            {/* <input type="text" className="col-sm-12 form-control-sm" name="pejabat_ttd" /> */}
                            <AsyncPaginate
                                loadOptions={loadOptionPenandatangan}
                                value={valueTtdOpt}
                                getOptionValue={(option) => option.namaPenandatangan}
                                getOptionLabel={(option) => option.namaPenandatangan}
                                additional={{
                                    page: 0
                                }}
                                onChange={onChangePenandatangan}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-2 col-form-label-sm">Jabatan Penandatangan</label>
                        <div className="col-sm-10">
                            <input type="text" className="col-sm-12 form-control-sm" name="jabatan_ttd" defaultValue={valueTtdJabatan} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SaveSpt()} >Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={handleCloseAddSpt}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSpt &&
                <SweetAlert
                    title="Simpan SPT?"
                    warning
                    showCancel
                    confirmBtnText="Proses"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSpt}
                    onCancel={handleCloseConfirmSpt}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                />
            }
            {
                showSptSuccess &&
                <SweetAlert
                    title="Penugasan Berhasil"
                    success
                    onConfirm={handleClickSptSuccess}
                    btnSize="sm"
                />
            }
            {
                showSptFailed &&
                <SweetAlert
                    title="Penugasan Gagal"
                    danger
                    onConfirm={handleClickSptFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalSpt